import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import env from '../env';

export const userApi = createApi({
    reducerPath: 'user',
    baseQuery: fetchBaseQuery({ baseUrl: env.baseUrl }),
    endpoints: (build) => ({
        loginUser: build.mutation({
            query(user) {
                return {
                    url: `login`,
                    method: 'POST',
                    body: user
                }
            }
        })
    }),
})

export const {
    useLoginUserMutation
} = userApi